import axios from "axios";

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("arclyst_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export async function streamAI(kind, payload, onDelta) {
  const response = await fetch(`${API_URL}/ai/${kind}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("arclyst_token")}` },
    body: JSON.stringify(payload),
  });
  if (!response.ok) throw new Error("AI request failed");
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const chunks = buffer.split("\n\n"); buffer = chunks.pop();
    chunks.forEach((chunk) => {
      if (!chunk.startsWith("data: ")) return;
      const event = JSON.parse(chunk.slice(6));
      if (event.type === "delta") onDelta(event.content);
      if (event.type === "error") throw new Error(event.content);
    });
  }
}